import React, {useContext} from 'react';
import moment from 'moment-timezone';
import 'index.css';
import './CartoucheSeance.scss';
import Typography from '@material-ui/core/Typography';
import DialogActions from '@material-ui/core/DialogActions';
import Grid from '@material-ui/core/Grid';
import SwiperCore, {Autoplay} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import _ from 'lodash';
import {useTranslation} from 'react-i18next';
import PayButton from 'components/Seances/PayButton';
import AfficheImage from 'components/Shared/AfficheImage';
import Context from 'utils/Context';
import TimezoneNote from 'components/TimezoneNote';
import {useTimezone} from 'hooks';

SwiperCore.use([Autoplay]);

const swiperParams = {
  speed: 800,
  spaceBetween: 30,
  centeredSlides: true,
  loop: true,
  autoplay: {
    delay: 2000,
    disableOnInteraction: false,
  },
};

function getIntervenants(value, modele) {
  if (Array.isArray(value)) return value;
  return value.split(',')
    .map(id => _.find(modele.intervenants, {id: parseInt(id)}))
    .filter(Boolean);
}

const CartoucheSeance = ({onPay, seance, hideBtns}) => {
  const {t} = useTranslation();
  const {appState, modele} = useContext(Context);
  const {displayTimezone, localTimezone} = useTimezone(seance.zone_name);

  const renderContent = () => {
    if (!seance.intervenants) {
      return (
        <div className="seance-cartouche-intervenant" key="cinema">
          <div className="seance-cartouche-intervenant-texte">
            <Typography variant="h5" component="h2" noWrap>
              {seance.film_name || `(${t('sans-titre')})`}
            </Typography>
            <Typography variant="h5" component="h2" noWrap>
              <small className="semi">{seance.city_name}</small>
            </Typography>
            <Typography variant="h5" component="h2" noWrap>
              {seance.cinema_name || `(${t('sans-titre')})`}
            </Typography>
            {seance.event_id > 0 && (
              <Typography variant="body1" component="p" noWrap>
                {t('seance-suivie-dune-rencontre')}
              </Typography>
            )}
          </div>
        </div>
      );
    }

    const intervenants = getIntervenants(seance.intervenants, modele);

    return (
      <Swiper {...swiperParams}>
        <SwiperSlide className="seance-cartouche-intervenant" key="cinema">
          <div className="cartouche-texte">
            <Typography variant={appState.screenSize === 'xs' ? 'h6' : 'h5'} component="h2" noWrap className="notop">
              {seance.film_name || `(${t('sans-titre')})`}
            </Typography>
            <Typography variant={appState.screenSize === 'xs' ? 'h6' : 'h5'} component="h2" noWrap className="nobottom">
              <small className="semi">{seance.city_name}</small>
            </Typography>
            <Typography variant={appState.screenSize === 'xs' ? 'h6' : 'h5'} component="h2" noWrap>
              {seance.cinema_name || `(${t('sans-titre')})`}
            </Typography>
            <Typography variant="body1" component="p" noWrap>
              {t('seance-suivie-dune-rencontre')}
            </Typography>
          </div>
        </SwiperSlide>
        {intervenants.map(intervenant => (
          <SwiperSlide className="seance-cartouche-intervenant" key={intervenant.id}>
            <Grid container spacing={0}>
              <Grid item xs={8}>
                <div className="seance-cartouche-intervenant-texte">
                  <Typography variant="caption" component="p" align="right">
                    {t('avec')}
                  </Typography>
                  <Typography variant={appState.screenSize === 'xs' ? 'h6' : 'h5'} component="p" align="right">
                    {intervenant.nom}
                  </Typography>
                  <Typography
                    variant={appState.screenSize === 'xs' ? 'subtitle1' : 'h5'}
                    component="p"
                    align="right"
                    className="semi notop"
                  >
                    {intervenant.qualite}
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={4}>
                <AfficheImage affiche={intervenant.photo} alt={`${intervenant.nom} speaker`} />
              </Grid>
            </Grid>
          </SwiperSlide>
        ))}
      </Swiper>
    );
  };
  const tzStartTime = seance.tzStartTime ? seance.tzStartTime : moment.tz(seance.start_time, seance.zone_name);
  const startTime = moment(tzStartTime).tz(displayTimezone);
  if (!startTime) {
    return null;
  }

  return (
    <div className="seance-cartouche shadow">
      <div className="seance-cartouche-content">
        <Typography variant={appState.screenSize === 'xs' ? 'h6' : 'h4'} noWrap>
          {startTime.format('LL ')}
          <small className="semi">
            {startTime.format('LT')}
            {displayTimezone !== localTimezone && <sup>*</sup>}
          </small>
        </Typography>
      </div>
      <div className="spacer" />
      <Grid container spacing={0}>
        <Grid item xs={3}>
          <AfficheImage affiche={seance.affiche} />
        </Grid>
        <Grid item xs={9}>
          {renderContent()}
        </Grid>
      </Grid>
      <TimezoneNote timezone={seance.zone_name} />

      <DialogActions>{!hideBtns && <PayButton onPay={onPay} showAccess seance={seance} />}</DialogActions>
    </div>
  );
};

export default CartoucheSeance;
